import { Box } from "@chakra-ui/react";
import TicketsByBranchTable from "../tables/TicketsByBranchTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";


const TicketsByBranch = ({ data, renderConfig, onRenderConfigChange }) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Branch" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Branch Ticket Distribution Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      {data.map((branchData, index) => {
        return (
          <Box key={index} className="reportContainer" mt="20px">
            <TicketsByBranchTable
              index={index}
              branchData={branchData}
              renderConfig={renderConfig}
              onRenderConfigChange={onRenderConfigChange}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default TicketsByBranch;
